<script setup>
import {useAuthenticationStore} from '@/stores/authentication.js';
import {onMounted, ref} from "vue";
import createApiService from "@/services/api.js";
import {useRouter} from "vue-router";
import AccredisImportResultDialog from "@/components/dashboard/accredisImportResultDialog.vue";
import { useI18n } from 'vue-i18n';
import { useTitle } from 'vue-page-title';
import { useFilters } from '@/composables/useFilters.js';
import {useConfigStore} from "@/stores/config.js";

const { t } = useI18n();
const { formatDate, ucFirst } = useFilters();

const { setTitle } = useTitle();
setTitle(t('dashboard.title'));

const router = useRouter();
const api = createApiService(router);
const dashboard = ref([]);
const showAccredisDialog = ref(false);
const configStore = useConfigStore();

definePage({
  meta: {
    requiresAuth: true,
  },
});

onMounted(() => {
  updateDashboard();
});

const updateDashboard = () => {
  api
    .get("dashboard")
    .then((response) => {
      dashboard.value = response.data.data;
    })
    .catch((error) => {
      console.log(error);
    });
};

const accredisHasErrors = () => {
  return dashboard.value.last_accredis_import_result && dashboard.value.last_accredis_import_result.some(item => item.errors && item.errors.length > 0);
};

const authStore = useAuthenticationStore();
</script>

<template>
  <accredis-import-result-dialog
    v-model="showAccredisDialog"
    :dashboard="dashboard"
  />

  <v-card>
    <v-card-title>
      {{ t('dashboard.welcome', { name: authStore.getCurrentUserName() }) }}
    </v-card-title>
    <v-card-text>
      <p>{{ t('dashboard.todayIs') }} <b>{{ formatDate(new Date()) }}</b>.</p>
      <v-container
        fluid
        class="pa-0 mt-4"
      >
        <v-table class="dashboard">
          <tr>
            <th>
              {{ t('dashboard.projectsToday') }}
            </th>
            <td>
              {{ dashboard.events_today }}
            </td>
          </tr>
          <tr v-if="configStore.currentLocation.time_registration">
            <th>
              {{ t('dashboard.lastAccredisImport') }}
            </th>
            <td>
              {{ ucFirst(formatDate(dashboard.last_accredis_import)) }}
              <v-icon
                v-if="dashboard.last_accredis_import"
                class="ml-2"
                :icon="accredisHasErrors() ? 'mdi-close-octagon' : 'mdi-information'"
                :color="accredisHasErrors() ? 'error' : 'primary'"
                @click="showAccredisDialog = true"
              />
            </td>
          </tr>
          <tr v-if="configStore.currentLocation.time_registration">
            <th>
              {{ t('dashboard.workdaysToCheck') }}
            </th>
            <td>
              {{ dashboard.open_workdays }}
            </td>
          </tr>
        </v-table>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<style lang="scss">
.dashboard table {
  width: 500px !important;

  th {
    text-align: left;
    padding-right: 15px;
    white-space: nowrap;
  }

  td {
    white-space: nowrap;
  }
}

</style>
